export const queryKeys = {
	songs: {
		all: () => ["songs"] as const,
		list: () => ["songs", "list"] as const,
		refrainList: () => ["songs", "refrainList"] as const,
		ordinaireList: () => ["songs", "ordinaireList"] as const,
		detail: (id: number) => ["songs", id] as const,
		allTagged: () => ["songs", "allTagged"] as const,
	},
	tags: { all: () => ["tags"] as const },
	setlists: {
		list: () => ["setlists", "list"] as const,
		history: () => ["setlists", "history"] as const,
		detail: (id: string) => ["setlists", id] as const,
		items: (id: string) => ["setlists", id, "items"] as const,
	},
	ordinaires: {
		list: () => ["ordinaires", "list"] as const,
		detail: (id: number) => ["ordinaires", id] as const,
	},
	texts: {
		list: () => ["texts", "list"] as const,
		detail: (id: number) => ["texts", id] as const,
	},
};
